import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=ed3e2a16"
import script from "./RouteDetails.vue?vue&type=script&lang=ts"
export * from "./RouteDetails.vue?vue&type=script&lang=ts"
import style0 from "./RouteDetails.vue?vue&type=style&index=0&id=ed3e2a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports